import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const DeleteFileIcon = (props: IconProps) => (
  <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <circle cx="12" cy="12" r="10.5" stroke="#fff" strokeWidth="3" />
    <path
      fill="#fff"
      d="m16.666 8.274-.94-.94-3.727 3.726-3.726-3.727-.94.94L11.059 12l-3.726 3.727.94.94 3.726-3.727 3.727 3.727.94-.94L12.939 12l3.727-3.726Z"
    />
  </Icon>
);

export default memo(DeleteFileIcon);
